import React, { Component } from 'react';
import { Media, NavDropdown, MenuItem } from 'react-bootstrap';
import { map } from 'lodash';
import ReviewReply from './ReviewReply'
import { timeSince } from '../../helpers';

class ReviewCard extends Component {
  constructor() {
    super()
    this.state = {
      replyBox: false,
      replyText: null,
      editReply: false,
      smallScreen:false,
    }
  }


  componentWillMount() {
    window.addEventListener('mousedown', this.bodyClick.bind(this));
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
    this.updateWindowDimensions()
  }
  componentWillUnmount() {
    window.removeEventListener('mousedown', this.bodyClick.bind(this));
  }
  updateWindowDimensions() {
    if (window.innerWidth < 640 ) {
      this.setState({smallScreen:true});
    }
  }
  bodyClick(e) {
    // if (!e.target.closest('#reply_0') || e.target.closest('#reply_0').id != "reply_" + this.props.index) {
    if (this.state.replyBox) {
      if (!e.target.closest("#replyBox_" + this.props.index)) {
        this.setState({ replyBox: false });
      }
      else if (e.target.closest("#replyBox_" + this.props.index).id != "replyBox_" + this.props.index) {
        this.setState({ replyBox: false });
      }
    }
  }

  render() {
    let { data, sentReply, actions } = this.props;
    let reviewDate = new Date(data.createdAt);
    let seconds = Math.floor((new Date() - reviewDate) / 1000);
    if (seconds > 82800) {
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let createdAt = data && new Date(data.createdAt);
      reviewDate = months[createdAt.getMonth()] + ' ' + createdAt.getDate() + ' , ' + createdAt.getFullYear();
    } else {
      reviewDate = timeSince(new Date(new Date(data.createdAt).getTime())) + ' Ago';
    }
    return (
      <div className="review-card-holder">
        <div className="review-card">
          <div>
            <Media>
              <span className="time-left">{reviewDate}</span>
              <Media.Left>
                <img className="rating-img" src={data && data.profilePhoto ? data.profilePhoto : "../../images/placeholder.png"} alt="Image" />
              </Media.Left>
              <Media.Body>
                <Media.Heading>{data.name}
                  <span className="star-group">
                    {data.rating > 0 ? <i className="mdi mdi-star full" /> : <i className="mdi mdi-star empty" />}
                    {data.rating > 1 ? <i className="mdi mdi-star full" /> : <i className="mdi mdi-star empty" />}
                    {data.rating > 2 ? <i className="mdi mdi-star full" /> : <i className="mdi mdi-star empty" />}
                    {data.rating > 3 ? <i className="mdi mdi-star full" /> : <i className="mdi mdi-star empty" />}
                    {data.rating > 4 ? <i className="mdi mdi-star full" /> : <i className="mdi mdi-star empty" />}
                  </span>
                </Media.Heading>
                {!this.state.smallScreen && <p>{data.comments}</p>}
              </Media.Body>
              {this.state.smallScreen && <p className="n-rating-text" >{data.comments}</p>}

            </Media>
            <div>
              {map(data.comments_on_review, (comments, key) => {
                return (
                  <ReviewReply actions={actions} key={key} index={key} commentId={data.id} comments={comments} sentReply={sentReply} />
                )
              })}

            </div>

          </div>

          <span className="reply-text" onClick={() => this.setState({ replyBox: true })}>Reply</span>
        </div>
        {this.state.replyBox && <div className="review-card reply-text" id={`replyBox_${this.props.index}`}>
          <input type="text" name="" onChange={(e) => this.setState({ replyText: e.target.value })} />
          <span className="send-icon" onClick={() => {
            this.props.replyVal(this.state.replyText, this.props.index);
            this.props.actions.addComments(this.state.replyText, false, data.id);
            this.setState({ replyBox: false });
          }}><i className="mdi mdi-send"></i></span>
        </div>}

      </div>
    );
  }
}

export default ReviewCard;



// WEBPACK FOOTER //
// ./src/components/ReviewRating/ReviewCard.jsx